// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c3b43861","732":"f4849682","977":"a970d119"}[chunkId] + ".chunk.js";
};